<component-factory [component]="component" [inputs]="customComponentdata" #editComponent></component-factory>